import { cachePromise } from './../util/cache_promise';

const MessageThreadsService = cachePromise((params) => {
  const urlParams = { subdomain_param: 'api' };
  const queryParams = Object.assign({ user_id: Aedu.User.current.id }, params);

  return $.ajax({
    url: $r.api_v0_message_threads_path(urlParams),
    type: 'GET',
    data: queryParams,
    dataType: 'json',
  });
});

export { MessageThreadsService };
